export default "__VITE_ASSET__aab2613a__"